import { icon } from './Icon';

export interface Crumb {
  label: string;
  href?: string;
  icon?: string;
}

/** Hierarchy breadcrumb: National › Sector › Sub-domain. */
export function Breadcrumb(crumbs: Crumb[]): string {
  const items = crumbs
    .map((c, i) => {
      const inner = `${c.icon ? icon(c.icon, 'icon icon-xs') : ''}<span>${c.label}</span>`;
      const node = c.href && i < crumbs.length - 1
        ? `<a href="#/${c.href}">${inner}</a>`
        : `<span class="current" aria-current="page">${inner}</span>`;
      const sep = i < crumbs.length - 1 ? '<span class="sep">›</span>' : '';
      return node + sep;
    })
    .join('');
  return `<nav class="crumbs" aria-label="breadcrumb">${items}</nav>`;
}
